import defaultRole from "constant/config.role";

export const Chat = {
    id: `Chat`,
    title: `Chat`,
    type: `item`,
    url: `${defaultRole.profile}/help/chat`,
    icon: `chat`,
    breadcrumbs: false,
    parentId: "HelpSupport"
}

export const Mail = {
    id: `Mail`,
    title: `Mail`,
    type: `item`,
    url: `${defaultRole.profile}/help/mail`,
    icon: `draft`,
    breadcrumbs: false,
    parentId: "HelpSupport"
}

export const contact = {
    id: `contact`,
    title: `Contact Info`,
    type: `item`,
    url: `${defaultRole.profile}/help/support`,
    icon: `draft`,
    breadcrumbs: false,
    parentId: "HelpSupport"
}

export const Documents = {
    id: `documents`,
    title: `Documents`,
    type: `item`,
    url: `${defaultRole.profile}/mybusiness/documents`,
    icon: `description`,
    breadcrumbs: false,
    parentId: "my_business",
    activeItem: [`/${defaultRole.profile}/mybusiness/documents`, `/${defaultRole.profile}/mybusiness/document-sign`]
}

export const accidentreport = {
    id: `accidentreport`,
    title: `Accident Report`,
    type: `item`,
    url: `${defaultRole.profile}/mybusiness/accidentreport`,
    icon: `accidentform`,
    breadcrumbs: false,
    parentId: "my_business",
    activeItem: [`/${defaultRole.profile}/mybusiness/accidentreport`, `/${defaultRole.profile}/mybusiness/accidentform`, `/${defaultRole.profile}/mybusiness/accidentform/edit`, `/${defaultRole.profile}/mybusiness/accidentform/view`, `/${defaultRole.profile}/mybusiness/report-document-sign`, `/${defaultRole.profile}/mybusiness/report-docusign-verification`]
}

export const adminagent = {
    id: `dashboard`,
    title: `Dashboard`,
    type: `group`,
    children: [
        {
            id: `default`,
            title: `Dashboard`,
            type: `item`,
            url: `${process.env.REACT_APP_DC_URL}profile/services`,
            icon: `gridView`,
            breadcrumbs: false,
            href: true,
        },
        {
            id: `services`,
            title: `Services`,
            type: `item`,
            url: `${process.env.REACT_APP_FHT_URL}login`,
            icon: `gridView`,
            breadcrumbs: false,
            href: true,
        },
        {
            id: `member_portal`,
            title: `Member Portal`,
            type: `collapse`,
            url: `${defaultRole.profile}/portal/dashboard`,
            icon: `gridView`,
            breadcrumbs: false,
            children: [
                {
                    id: `default`,
                    title: `Dashboard`,
                    type: `item`,
                    url: `${defaultRole.profile}/portal/dashboard`,
                    icon: `gridView`,
                    breadcrumbs: false,
                    parentId: "member_portal"
                }
            ]
        },
        {
            id: `my_business`,
            title: `My Business`,
            type: `collapse`,
            url: ``,
            icon: `gridView`,
            breadcrumbs: false,
            children: []
        },
        {
            id: `HelpSupport`,
            title: `Help & Support`,
            type: `item`,
            url: `${defaultRole.profile}/helpsupport`,
            icon: `vehicleowner`,
            breadcrumbs: false,
            children: [Chat, Mail, contact]
        },
    ]
};

export const otheruser = {
    id: `dashboard`,
    title: `Dashboard`,
    type: `group`,
    children: [
        {
            id: `default`,
            title: `Dashboard`,
            type: `item`,
            url: `${process.env.REACT_APP_DC_URL}profile/services`,
            icon: `gridView`,
            breadcrumbs: false,
            href: true,
        },
        {
            id: `services`,
            title: `Services`,
            type: `item`,
            url: `${process.env.REACT_APP_FHT_URL}login`,
            icon: `gridView`,
            breadcrumbs: false,
            href: true,
        },
        {
            id: `member_portal`,
            title: `Member Portal`,
            type: `collapse`,
            url: `${defaultRole.profile}/portal/dashboard`,
            icon: `gridView`,
            breadcrumbs: false,
            children: [
                {
                    id: `default`,
                    title: `Dashboard`,
                    type: `item`,
                    url: `${defaultRole.profile}/portal/dashboard`,
                    icon: `gridView`,
                    breadcrumbs: false,
                    parentId: "member_portal"
                }
            ]
        },
        {
            id: `my_business`,
            title: `My Business`,
            type: `collapse`,
            url: ``,
            icon: `gridView`,
            breadcrumbs: false,
            children: []
        },
    ]
};
export const serviceagent = {
    id: `agenthouse`,
    title: `Service Representatives`,
    type: `item`,
    url: `/${defaultRole.profile}/mybusiness/serviceagent/view`,
    icon: `group`,
    breadcrumbs: false,
    parentId: "my_business",
    activeItem: [`/${defaultRole.profile}/mybusiness/serviceagent/view`, `/${defaultRole.profile}/mybusiness/serviceagent/edit`]
}

export const drivers = {
    id: `user`,
    title: `Drivers`,
    type: `item`,
    url: `/${defaultRole.profile}/mybusiness/driver/view`,
    icon: `wheel`,
    breadcrumbs: false,
    parentId: "my_business",
    activeItem: [`/${defaultRole.profile}/mybusiness/driver/view`, `/${defaultRole.profile}/mybusiness/createdriver`, `/${defaultRole.profile}/mybusiness/driver/view`, `/${defaultRole.profile}/mybusiness/driver/edit`]
}

export const fleet = {
    id: `fleet_operators`,
    title: `Fleet Operators`,
    type: `item`,
    url: `/${defaultRole.profile}/mybusiness/fleetoperator/view`,
    icon: `group`,
    breadcrumbs: false,
    parentId: "my_business",
    activeItem: [`/${defaultRole.profile}/mybusiness/fleetoperator/view`, `/${defaultRole.profile}/mybusiness/createfleet`, `/${defaultRole.profile}/mybusiness/fleetoperator/view`, `/${defaultRole.profile}/mybusiness/fleetoperator/edit`]
}

export const vehicleowner = {
    id: `vehicleowner`,
    title: `Vehicle Owner`,
    type: `item`,
    url: `/${defaultRole.profile}/mybusiness/vehicleowner/view`,
    icon: `vehicleowner`,
    breadcrumbs: false,
    parentId: "my_business",
    activeItem: [ `/${defaultRole.profile}/mybusiness/vehicleowner/view`, `/${defaultRole.profile}/mybusiness/vehicleowner/edit`]
}

export const serviceprovider = {
    id: `serviceprovider`,
    title: `Service Provider`,
    type: `item`,
    url: `/${defaultRole.profile}/mybusiness/serviceprovider/view`,
    icon: `serviceprovider`,
    breadcrumbs: false,
    parentId: "my_business",
    activeItem: [ `/${defaultRole.profile}/mybusiness/serviceprovider/view`, `/${defaultRole.profile}/mybusiness/serviceprovider/edit`]
}

export const vehicle = {
    id: `vehicle`,
    title: `Vehicles`,
    type: `item`,
    url: `${defaultRole.profile}/mybusiness/vehicles`,
    icon: `directionsCar`,
    breadcrumbs: false,
    parentId: "my_business",
    activeItem: [`/${defaultRole.profile}/mybusiness/vehicles`, `/${defaultRole.profile}/mybusiness/vehicle/edit`, `/${defaultRole.profile}/mybusiness/vehicle/view`, `/${defaultRole.profile}/mybusiness/editvehicle`]
}
export const vehiclepermit = {
    id: `vehiclepermit`,
    title: `Vehicle Permit`,
    type: `item`,
    url: `${defaultRole.profile}/mybusiness/vehiclepermits`,
    icon: `vehiclepermit`,
    breadcrumbs: false,
    parentId: "my_business",
    activeItem: [`/${defaultRole.profile}/mybusiness/vehiclepermits`, `/${defaultRole.profile}/mybusiness/vehiclepermit/view`, `/${defaultRole.profile}/mybusiness/vehiclepermit/edit`]
}
export const telematics = {
    id: `Telematics`,
    title: `Telematics`,
    type: `item`,
    url: `${defaultRole.profile}/mybusiness/telematics`,
    icon: `dongle`,
    breadcrumbs: false,
    parentId: "my_business",
    activeItem: [`/${defaultRole.profile}/mybusiness/telematics`, `/${defaultRole.profile}/mybusiness/telematics/view`, `/${defaultRole.profile}/mybusiness/telematics/edit`]
}
